// src/admin/components/TagForm.jsx

import { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";

export default function TagForm({
    initialValues = {},
    onSubmit,
    saving = false,
}) {

    const { isDark } = useTheme();

    const [formData, setFormData] = useState({
        name: initialValues?.name || "",
    });

    useEffect(() => {
        setFormData({
            name: initialValues?.name || "",
        });
    }, [initialValues]);

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-800/50"
                : "bg-white border-gray-300 focus:border-blue-800"
        }
    `;

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">

            <div>

                <label className="block mb-2 font-medium">
                    Tag Name
                </label>

                <input
                    type="text"
                    value={formData.name}
                    onChange={(e) =>
                        handleChange("name", e.target.value)
                    }
                    placeholder="e.g. React, Django, AI"
                    className={inputClass}
                />

            </div>

            <button
                type="submit"
                disabled={saving}
                className="
                    w-full
                    rounded-xl
                    bg-blue-800
                    py-3
                    font-semibold
                    text-white
                    transition
                    hover:bg-cyan-600
                    disabled:cursor-not-allowed
                    disabled:opacity-60
                "
            >
                {saving ? "Saving..." : "Save Tag"}
            </button>

        </form>
    );
}